export type UnassignedAction = 'Client review' | 'Recommended move'

export type UnassignedProduct = {
  sku: string
  title: string
  action: UnassignedAction
  /** Suggested destination in the restructured tree, when one is clear. */
  suggestion: string
  note: string
}

/**
 * Internal audit list: products currently assigned only to root / All
 * Categories, or with no meaningful category assignment. Report-only — this
 * bucket is never exposed in customer-facing navigation or category cards.
 */
export const UNASSIGNED_PRODUCTS: UnassignedProduct[] = [
  {
    sku: '02252',
    title: '22x36 Mat - Holly Ivy Border/Monogrammed',
    action: 'Client review',
    suggestion: 'Decision needed',
    note: 'Confirm keep under Outdoor Accessories & Home Accents, discontinue, or move elsewhere — Door Mats & Welcome Mats is being removed.',
  },
  {
    sku: '15000BR',
    title: 'Bacova American Classic Oval Monogram Burgundy',
    action: 'Client review',
    suggestion: 'Decision needed',
    note: 'Likely mat / decor accent, needs client decision.',
  },
  {
    sku: '15090BR',
    title: 'Bacova Quiet Mill Burgundy Oval',
    action: 'Client review',
    suggestion: 'Decision needed',
    note: 'Likely mat / decor accent, needs client decision.',
  },
  {
    sku: '15437FG',
    title: 'Bacova Tropy Deer Oval',
    action: 'Client review',
    suggestion: 'Decision needed',
    note: 'Likely mat / decor accent, needs client decision.',
  },
  {
    sku: 'NOCH-11EL',
    title: 'Drawer Safe',
    action: 'Client review',
    suggestion: 'Decision needed',
    note: 'No obvious category unless the client wants a safes / security category.',
  },
  {
    sku: 'NOCH-25EL',
    title: 'Personal .5 cu ft Safe',
    action: 'Client review',
    suggestion: 'Decision needed',
    note: 'No obvious category unless the client wants a safes / security category.',
  },
  {
    sku: 'NOBH-20EL',
    title: 'Personal 1.0 cu ft Safe',
    action: 'Client review',
    suggestion: 'Decision needed',
    note: 'No obvious category unless the client wants a safes / security category.',
  },
  {
    sku: 'NOCH-46EL',
    title: 'Personal 2.0 cu ft Safe',
    action: 'Client review',
    suggestion: 'Decision needed',
    note: 'No obvious category unless the client wants a safes / security category.',
  },
  {
    sku: 'MB404',
    title: 'Decorative Cedar Top Mount Post MB404',
    action: 'Recommended move',
    suggestion: 'Mailboxes › Mailbox Posts',
    note: 'Clear fit with the existing mailbox post assortment.',
  },
  {
    sku: '7006',
    title: 'Mail Boss 7006 Surface Mount Mailbox Post Granite',
    action: 'Recommended move',
    suggestion: 'Mailboxes › Mailbox Posts',
    note: 'Clear fit with the existing mailbox post assortment.',
  },
  {
    sku: '7007',
    title: 'Mail Boss 7007 Surface Mount Mailbox Post -Black',
    action: 'Recommended move',
    suggestion: 'Mailboxes › Mailbox Posts',
    note: 'Clear fit with the existing mailbox post assortment.',
  },
  {
    sku: '7008',
    title: 'Mail Boss 7008 Surface Mount Mailbox Post White',
    action: 'Recommended move',
    suggestion: 'Mailboxes › Mailbox Posts',
    note: 'Clear fit with the existing mailbox post assortment.',
  },
  {
    sku: '7009',
    title: 'Mail Boss 7009 Surface Mount Mailbox Post Bronze',
    action: 'Recommended move',
    suggestion: 'Mailboxes › Mailbox Posts',
    note: 'Clear fit with the existing mailbox post assortment.',
  },
  {
    sku: 'LTO-1302',
    title: 'QualArc Edgewood Lighted Address Plaque',
    action: 'Recommended move',
    suggestion:
      'Outdoor Accessories & Home Accents › Address Plaques & House Numbers › Illuminated Address Plaques',
    note: 'Lighted plaque belongs with the new illuminated address plaque grouping.',
  },
  {
    sku: '14247',
    title: 'Whitehall Illuminator Solar Address Lamp 14247',
    action: 'Recommended move',
    suggestion:
      'Outdoor Accessories & Home Accents › Address Plaques & House Numbers › Illuminated Address Plaques',
    note: 'Solar address lamp belongs with the new illuminated address plaque grouping.',
  },
]
